import { memo } from "react";
import { useContent } from "../../../../../contexts/contentContext/contentContext";
import Button from "../../../../Elements/Button/Button";
import { LinkToNewTab } from "../../../../Elements/Link/Link";

import styles from "./styles.module.scss";

const UnlockAllSection = memo(() => {
  const { getTextByKey } = useContent();

  return (
    <div className={styles.unlockAllWrapper}>
      <h2>{getTextByKey("unlock-all-title")}</h2>
      <h3>{getTextByKey("unlock-all-description")}</h3>
      {/*@ts-ignore*/}
      <LinkToNewTab page="plans">
        <Button>{getTextByKey("see-plans")}</Button>
      </LinkToNewTab>
    </div>
  );
});

export default UnlockAllSection;
